angular.
module("dx.webapp.api").
factory("dxApiV1Rubrics", function apiV1RubricsService(
	$http
) {
	"use strict";

	function shareRubricsRecipientsGet(rubricId) {
		return $http.get("api/v1/rubrics/" + rubricId + "/shares/recipients");
	}

	function shareRubricsRecipientDelete(rubricId, userId) {
		return $http.delete("api/v1/rubrics/" + rubricId + "/shares?userId=" + userId);
	}

	return {
		shares: {
			get: shareRubricsRecipientsGet,
			delete: shareRubricsRecipientDelete,
		},
	};
});
